// 报警服务 - 介绍
import qs from 'qs'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import Helmet from 'react-helmet'
import ReactTooltip from 'react-tooltip'
import Demo from 'src/assets/images/monitoring/icons/demo.svg'
import { judgeClient } from 'src/common/browser'
import { t } from 'src/common/i18n'
import {
  INativeInfo,
  getNativeInfo,
  openWebview,
  togglePullToRefresh,
  uploadTrackings,
} from 'src/common/jsbridge'
import request from 'src/common/request'
import Collapse from 'src/components/collapse'
import Modal from 'src/components/modal'
// import { decrypt } from 'src/common'
import { useAsyncEffect, useScroll, useUpdateEffect } from 'ahooks'
import classnames from 'classnames'
import { navigate } from 'gatsby'
import { animateScroll as Scroll } from 'react-scroll'
import {
  getAlramServiceWaysToBuy,
  jumpToPlan,
  nativeApp,
} from 'src/common/bridge'
import { compareVersion, isQa, isV2ApiAvail } from 'src/common/utils'

import Swiper, { Autoplay } from 'swiper'
import 'swiper/css/bundle'
// import useBFSalesActivity from 'src/hooks/useBFSalesActivity'

import BackIcon from 'src/assets/images/backs.png'
import banner1 from 'src/assets/images/banner1@2x.jpg'
import banner2 from 'src/assets/images/banner2@2x.jpg'
import banner3 from 'src/assets/images/banner3@2x.jpg'
import Select from 'src/assets/images/monitoring/icons/select.svg'
import Selected from 'src/assets/images/monitoring/icons/selected.svg'
// import loading from 'src/assets/images/loading.png'
import sec30 from 'src/assets/images/monitoring/30sec.png'
import sec5 from 'src/assets/images/monitoring/5sec.png'
import sec60 from 'src/assets/images/monitoring/60sec.png'
import origin_img_v1 from 'src/assets/images/origin_img_v1.png'
import origin_img_v2 from 'src/assets/images/origin_img_v2.png'

import * as styles from './intro.module.scss'

Swiper.use([Autoplay])
interface IBenifit {
  icon: string
  description: string
}

interface IAction {
  icon: string
  title: string
  description: string
}

interface IPlan {
  id: string
  title: string
  display_price: string
  dispatch?: string
}

interface IHtw {
  icon: string
  title?: string
  description: string
}

export interface IComparison {
  description: string
  info?: string
  plus: boolean
  basic: boolean
  noplan: boolean
}

interface Config {
  title: string
  banner?: {
    img: string
    desc: string
  }
  reasons?: {
    title: string
    list: Array<{
      icon: string
      description: string
    }>
  }
  plans?: IPlan[]
  planStyles?: IPlan[]
  benifits: {
    basic: IBenifit[]
    plus: IBenifit[]
  }
  htws: {
    basic: IHtw[]
    plus: IHtw[]
  }
  actions: IAction[]
  comparisons: IComparison[]
  faqs: string[][]
}

/**
 * get_current_subscription 返回 Subscriptions 元素类型
 */
type Subscription = {
  id: number
  // 0: basic 套餐; 1: plus 套餐
  device_type: 0 | 1
  device_sn: string
  is_trial: number | boolean
  class_id: number
  event_id: string
  buy_channel: string
  service_code: string
}

type CurrentSubscription = {
  Subscriptions: Array<Subscription>
  trialed: boolean
  user_subscription_stat?: {
    recall_user?: boolean
    sub_basic_upgrade_user?: boolean
    sub_plus_upgrade_user?: boolean
    never_subscribe?: boolean
  }
}

const VERSION = isV2ApiAvail() ? 'v2' : 'v1'

function getCurrentSubscription(device_sn?: string, station_sn?: string) {
  const url = `/${VERSION}/commerce/get_current_subscription`
  return request<CurrentSubscription>({
    url,
    method: 'post',
    data: {
      service_code: 'monitoring.service',
      is_new_version: 1,
      // page: 0,
      // num: 100,
      // package_no: '',
      // device_sn: device_sn || null,
      // station_sn: device_sn ? station_sn : null,
    },
  })
  // .then(async(res) => {
  //   console.log(res,res.data, 'res')
  //   if (res.data && res.data.user_subscription_stat) {
  //     res.data.user_subscription_stat.recall_user = true
  //     res.data.user_subscription_stat.sub_basic_upgrade_user = true
  //     res.data.user_subscription_stat.sub_plus_upgrade_user = true
  //   }
  //   return res.data
  //   // if (isV2ApiAvail() && typeof res.data === 'string') {
  //   //   const data = await decrypt({type: 0, data: res.data})
  //   //   return {
  //   //     ...res,
  //   //     data
  //   //   }
  //   // }
  //   // return res
  // })
}

const isIntroPage = (page: string) => page === 'intro'

const FAQs = (isTrialAvailable, faqs) =>
  [
    isTrialAvailable
      ? [
          `Is there a free monitoring service trial?`,
          `[Special Offer]: You can experience the free trial after filling out your credit card information. The service fee will be automatically be charged for the next month after the trial has finished. You are welcome to cancel your subscription at any time.`,
        ]
      : null,
    ...faqs,
  ].filter(Boolean)
const luckyDrawPopUpTxt =
  'Please go to <a href="https://mysecurity.eufylife.com/#/redeem">eufylife.com</a>, log in, and go to "Additional Service - Redeem" under "My Service Portal" to get your free month of Protection Plan. See the benefits of Protection Plan here.'
type DataProps = {
  trialable?: boolean
  config: Config
  hideTab?: boolean
  hideTryDemo?: boolean
  showSwiperBanner?: boolean
  payTrackid?: number
  exposeTrackid?: number
  initPlan?: number
  page: string
}
interface UrlParams {
  entrance?: string
  subscribeType?: number
  [k: string]: string | number
}

let urlParams: UrlParams = {
  entrance: '',
  subscribeType: 0,
}

const UtmTrackId = {
  expose: 1900179,
  getStart: 1900180,
}

// const SERVER_CODE = 'monitoring.service'

// let checkEndNumber = 1;
let isBasicTrialed
let isPlusTrialed
// let tabTop = 10000
const MonitoringServicePage: React.FC<DataProps> = props => {
  const { planStyles, plans, htws, comparisons, benifits } = props.config
  // 免费试用是否开启
  const [isTrialAvailable] = useState<boolean>(props.trialable)
  const [modalVisible, setModalVisible] = useState<boolean>(false)
  const [tips, setTips] = useState<boolean>(false)
  const [checkEndVal, setCheckEndVal] = useState<Number>(props?.initPlan ?? 1)
  const [package_no, setPackageNo] = useState<string>('')
  const [packagePlus_no, setPackagePlusNo] = useState<string>('')
  // const [pro_id, setProid] = useState<string>('')
  // const [pro_plus_id, setProPlusid] = useState<string>('')
  // const [basicClassId, setBasicClassId] = useState<string>('')
  // const [plusClassId, setPlusClassId ] = useState<Number>()
  const [classList, setClassList] = useState<Array<number>>([])
  const [stopTime, setTopTime] = useState<Number>(0)
  const [btnText, setBtnText] = useState<string>('')
  const [emailText, setEmail] = useState<string>('')
  const [utm, setUtm] = useState<{ [k: string]: string }>({})
  const [planStyle, setPlanStyle] = useState(planStyles?.[0]?.id)
  const [isIOS, setIsIOS] = useState(false)
  const [isAndroid, setIsAndroid] = useState(false)
  const [subscriptions, setSubscriptions] = useState<Subscription[]>([])
  const [subscribedModalVisible, setSubscribedModalVisible] = useState<boolean>(false)
  const [isTrial, setIsTrialed] = useState(false)
  const [nativeInfo, setNativeInfo] = useState<INativeInfo>()
  const [checkEndNumber, setCheckEndNumber] = useState(1)
  // const [termsShow, setTermsShow] = useState<boolean>(false)
  // 下架弹框

  const [queryUrl, setQueryUrl] = useState<{ [k: string]: string | number }>()
  // 年付价格信息
  const [yearPriceBasic, setYearPriceBasic] = useState<{
    price: number
    oldPrice?: number
  } | null>(null)
  const [yearPricePlus, setYearPricePlus] = useState<{
    price: number
    oldPrice?: number
  } | null>(null)
  const [newYearSupport, setNewYearSupport] = useState<boolean>(false)
  const [newYearPrice, setNewYearPrice] = useState<
    Array<{ package_no: string; buy_channel: string; price: number }>
  >([])
  // 活动是否开启（活动开启且国家支持）
  const [isActivityEnabled, setIsActivityEnabled] = useState<boolean>(false)
  // 用户类型：3 表示新用户
  const [userType, setUserType] = useState<number | null>(null)
  // 保存年付数据的 package_no，用于匹配折扣价格
  const [yearPackageNoBasic, setYearPackageNoBasic] = useState<string>('')
  const [yearPackageNoPlus, setYearPackageNoPlus] = useState<string>('')
  const [yearOriginalPriceBasic, setYearOriginalPriceBasic] = useState<number>(
    0
  )
  const [yearOriginalPricePlus, setYearOriginalPricePlus] = useState<number>(0)

  const tabRef = useRef(null)
  const scroll = useScroll(typeof window === 'undefined' ? null : document)

  // 判断用户类型
  const getUserType = useCallback((subscriptions: CurrentSubscription | null): number => {

    const userSubscriptionStat = subscriptions?.user_subscription_stat
    // 召回用户
    if (userSubscriptionStat?.recall_user) {
      return 1
    }
    // 升级用户
    else if (userSubscriptionStat?.sub_basic_upgrade_user || userSubscriptionStat?.sub_plus_upgrade_user) {
      return 2
    }
    // 普通订阅过的用户
    else if (subscriptions?.Subscriptions && subscriptions?.Subscriptions !== null && subscriptions.Subscriptions.length > 0) {
      return 0
    }
    // // 试用过但未订阅的用户，3跟4区别就是按钮不展示30试用
    // else if (userSubscriptionStat?.never_subscribe === false) {
    //   return 4
    // }
    // 新用户（试用用户）
    return 3
  }, [])

  // 抽奖跳转提示弹框是否显示
  const [luckyInfoVisible, setLuckyInfoVisible] = useState(false)
  const [openEmailTextTips, setOpenEmailTextTips] = useState<string>('')
  const { search } =
    typeof window !== 'undefined' ? window.location : { search: '' }
  const isJump = search.indexOf('?jump=3') > -1

  // const { isAllowActivity } = useBFSalesActivity({
  //   support: false,
  //   server: SERVER_CODE,
  //   isTrialed: isTrial,
  //   subscriptions,
  //   allowVersion: {
  //     android: 'V4.4.9',
  //     ios: 'v99.99.99'
  //   },
  //   AllowCountry: ['us']
  // })

  // 初始化轮播
  const startBanner = () => {
    new Swiper('.swiper-container', {
      direction: 'horizontal',
      loop: true,
      autoplay: {
        disableOnInteraction: false,
        delay: 1500,
      },
      navigation: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 15,
    })
  }

  // 获取用户信息
  const getUserInfo = async type => {
    const api: any = await getNativeInfo()
    const data =
      Object.prototype.toString.call(api) === '[object Object]'
        ? api
        : JSON.parse(api)
    if (type === 'version') {
      // 取最后一个下划线后的数值
      const versions = data?.appVersion?.split('_')
      let appVersion = versions[data.appVersion.split('_').length - 1]
      let version = null
      // 安卓兼容老版本和新版本
      //Number(appVersion) >= 1321
      if (compareVersion(data?.appVersion, 'v4.2.5_1321') >= 0) {
        version = 2
      } else if (Number(appVersion) >= 1083) {
        version = 1
      } else {
        version = 0
      }
      return version
    } else {
      return data ? data : ''
    }
  }

  // 获取套餐classId
  const getCloudPlanListClassList = (token: string) => {
    const url = `/v1/app/cloud/get_classes`
    request<any[]>({
      url,
      // headers: { 'X-Auth-Token': token },
      method: 'post',
      data: {
        service_code: 'monitoring.service',
      },
    })
      .then(resp => {
        if (resp.code === 0) {
          const classList = []
          resp.data?.forEach(item => {
            classList.push(item.id)
          })
          if (classList && classList.length > 0) {
            sessionStorage.setItem('classId', JSON.stringify(classList))
            // getPlusPlan(token,classList[1])
            // getBasicPlan(token, classList[0])
          }
          setClassList(classList)
        }
      })
      .catch(console.error)
  }

  // 打开邮箱
  const openEmail = () => {
    uploadTrackings({
      events: [
        {
          type: String(190094),
          extra: '',
          value: JSON.stringify({
            plan: checkEndNumber === 0 ? 'basic' : 'plus',
          }),
          ts: parseInt((Date.now() / 1000).toString()),
        },
      ],
    })
    let iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = 'eufysecurity://eufy/explore/openEmailClient'
    document.body.appendChild(iframe)
  }

  const scrollToTop = () => {
    Scroll.scrollToTop({
      duration: 500,
    })
  }

  const showTips = () => {
    setTips(true)
    setTimeout(() => {
      setTips(false)
    }, 3000)
  }

  const from = useMemo<string>(() => {
    const { from } = qs.parse(search, { ignoreQueryPrefix: true })
    return (from as string) || ''
  }, [search])

  // const sticky = useMemo(
  //   () => scroll?.top + 54 >= tabTop,
  //   [scroll]
  // )

  const backToTopVisible = useMemo(() => scroll?.top && scroll?.top >= 667, [
    scroll,
  ])

  // const subscriptionsMap = useMemo(
  //   () => {
  //     const basic = find(subscriptions, o => o.class_id === classList?.[0])
  //     const plus = find(subscriptions, o => o.class_id === classList?.[1])
  //     return [basic, plus]
  //   },
  //   [subscriptions, classList]
  // )

  // 提示
  const textTips = useCallback(
    (first: number) => {
      // first：1 首次发送，0 非首次发送
      if (emailText) {
        if (isIOS) {
          // ios-首次发送
          if (first === 1) {
            setOpenEmailTextTips(
              `We've sent you an email, please check the email you registered with eufy to start your Protection Plan.`
            )
          } else {
            // iOS-非首次发送
            setOpenEmailTextTips(
              `We've already sent you an email, please check the email you registered with eufy to start your Protection Plan.`
            )
          }
        } else {
          // 安卓新版-首次
          if (first === 1) {
            setOpenEmailTextTips(
              `We've sent an email to (${emailText}). Please check your email to get started with our Protection Plan.`
            )
          } else {
            // 安卓-非首次
            setOpenEmailTextTips(
              `We've already sent an email to (${emailText}). Please check your email to get started with our Protection Plan.`
            )
          }
        }
      } else {
        if (first === 1) {
          // Android旧版、iOS新旧版-首次
          setOpenEmailTextTips(
            `We've sent you an email, please check the email you registered with eufy to start your Protection Plan.`
          )
        } else {
          // Android旧版、iOS新旧版-非首次
          setOpenEmailTextTips(
            `We've already sent you an email, please check the email you registered with eufy to start your Protection Plan.`
          )
        }
      }
    },
    [emailText, isIOS]
  )

  // 发送邮件请求
  const postEmail = useCallback(() => {
    uploadTrackings({
      events: [
        {
          type: btnText === 'Start Trial' ? String(190092) : String(190090), // 事件名称
          extra: '',
          value: JSON.stringify({
            plan: checkEndNumber === 0 ? 'basic' : 'plus',
            entry: urlParams.entrance,
          }), // 事件参数
          ts: parseInt((Date.now() / 1000).toString()), // 时间戳(毫秒)
        },
      ],
    })
    const is_trial =
      Number(checkEndNumber) === 0 ? isBasicTrialed : isPlusTrialed
    const isPackage_no =
      Number(checkEndNumber) === 0 ? package_no : packagePlus_no
    // 0:basic,1plus
    request({
      url: `/v1/app/commerce/send_subscription_email`,
      headers: { Os_Type: isIOS ? 'Ios' : 'Android' },
      method: 'post',
      data: {
        opt_params: {
          ...utm,
          page: props?.page,
        },
        package_no: isPackage_no,
        entry: urlParams.entrance,
        is_trial,
      },
    }).then(res => {
      if (res.code === 0) {
        setModalVisible(true)
        textTips(1)
      } else if (res.code === 25044) {
        setModalVisible(true)
        textTips(0)
      } else {
        showTips()
      }
    })
  }, [
    btnText,
    package_no,
    packagePlus_no,
    textTips,
    utm,
    props.page,
    isIOS,
    checkEndNumber,
  ])

  const handleClick = useCallback(() => {
    const serviceCode = 'monitoring.service'
    const os_type = isAndroid ? 'android' : 'ios'
    const classId = classList[checkEndNumber]
    const planType = checkEndVal === 0 ? 'basic' : 'plus'

    // 检查是否已订阅（非试用），避免用户重复订阅
    if (subscriptions?.some(v => v.is_trial !== true)) {
      setSubscribedModalVisible(true)
      return
    }

    uploadTrackings({
      events: [
        {
          type: String(UtmTrackId.getStart), // 事件名称
          extra: JSON.stringify({
            ...utm,
            utm_medium: os_type,
          }),
          value: JSON.stringify({
            plan: planType,
            page: props.page,
            istrial: btnText === 'Start Trial',
          }), // 事件参数
          ts: parseInt((Date.now() / 1000).toString()), // 时间戳(毫秒)
        },
      ],
    })

    if (isAndroid && compareVersion(nativeInfo?.appVersion, 'v4.6.1_0') >= 0) {
      const params = `/monitoring/cloud/payment/?type=monitoring.service&planType=${planType}&referer=${
        urlParams.entrance || ''
      }&classId=${classId}&subscribeType=${
        urlParams?.subscribeType || 0
      }&packageName=${planType}&os_type=${os_type}&utm_source=${
        utm.utm_source
      }&utm_campaign=${
        utm.utm_campaign
      }&isTrialed=${false}&isAllowActivity=false&page=${props.page}&isTrail=${
        btnText === 'Start Trial' ? true : false
      }`
      // openWebview(params)
      navigate(params)
      return
    }

    if (isIOS && compareVersion(nativeInfo?.appVersion, 'v4.6.8') >= 0) {
      const params = `/monitoring/cloud/payment/?type=monitoring.service&planType=${planType}&referer=${
        urlParams.entrance || ''
      }&classId=${classId}&subscribeType=${
        urlParams?.subscribeType || 0
      }&packageName=${planType}&os_type=${os_type}&utm_source=${
        utm.utm_source
      }&utm_campaign=${
        utm.utm_campaign
      }&isTrialed=${false}&isAllowActivity=false&page=${props.page}&isTrail=${
        btnText === 'Start Trial' ? true : false
      }`
      // openWebview(params)
      navigate(params)
      return
    }

    !isIntroPage(props.page) &&
      uploadTrackings({
        events: [
          {
            type: String(props.payTrackid),
            extra: '',
            value: '',
            ts: parseInt((Date.now() / 1000).toString()),
          },
        ],
      })

    if (isIOS) {
      postEmail()
      return
    }
    if (isAndroid) {
      getUserInfo('version').then(version => {
        if (Number(version) === 2) {
          // 直接走邮件
          postEmail()
        } else {
          if (Number(version) === 1) {
            // console.log(1)
            // 发送邮件再次判断
            getAlramServiceWaysToBuy().then((val: string) => {
              if (JSON.parse(val || '{}')?.ways === 'email') {
                postEmail()
              } else {
                isIntroPage(props.page) &&
                  uploadTrackings({
                    events: [
                      {
                        type:
                          btnText === 'Start Trial'
                            ? String(190091)
                            : String(190093), // 事件名称
                        extra: '',
                        value: JSON.stringify({
                          plan: checkEndNumber === 0 ? 'basic' : 'plus',
                          entry: urlParams.entrance,
                        }), // 事件参数
                        ts: parseInt((Date.now() / 1000).toString()), // 时间戳(毫秒)
                      },
                    ],
                  })
                const classId = classList[checkEndNumber]
                const packageName = checkEndNumber === 0 ? 'basic' : 'plus'
                let iframe = document.createElement('iframe')
                iframe.style.display = 'none'
                iframe.src = `eufysecurity://eufy/vas/pay?packageName=${packageName}&classId=${classId}&serviceCode=monitoring.service`
                document.body.appendChild(iframe)
              }
            })
          } else {
            const entrance =
              from.split?.('-')?.[0] || (isJump ? 'shopBanner' : undefined)
            switch (checkEndNumber) {
              case 0:
                jumpToPlan(serviceCode, 1, entrance)
                break
              case 1:
                jumpToPlan(serviceCode, 2, entrance)
                break
              default:
            }
          }
        }
      })
    }
  }, [
    postEmail,
    btnText,
    classList,
    from,
    isJump,
    utm,
    checkEndVal,
    props?.page,
    props?.payTrackid,
    isIOS,
    isAndroid,
    nativeInfo?.appVersion,
    checkEndNumber,
    subscriptions,
  ])

  // 返回上一级
  const handleGoBack = useCallback(() => {
    const time =
      (Number(parseInt((Date.now() / 1000).toString())) - Number(stopTime)) *
      1000
    uploadTrackings({
      events: [
        {
          type: String(190089), // 事件名称
          extra: '',
          value: JSON.stringify({ time }), // 事件参数
          ts: parseInt((Date.now() / 1000).toString()), // 时间戳(毫秒)
        },
      ],
    })
    window.location.href = 'app://back'
  }, [stopTime])

  // 获取折扣信息
  const getNewYearSupport = useCallback(async () => {
    const url = '/v1/app/overall/get_params'
    try {
      const res = await request<any>({
        url,
        method: 'POST',
        data: {
          end_time: 0,
          num: 100,
          page: 0,
          param_name: 'monitoring_service_activity_config',
          start_time: 0,
        },
      })

      if (res.code === 0 && res.data?.[0]?.param_value) {
        const resObj = JSON.parse(res.data[0].param_value)
        console.log(resObj, 'resObj')

        // 获取国家信息
        const nativeInfo: any = await getNativeInfo()
        const nativeData =
          Object.prototype.toString.call(nativeInfo) === '[object Object]'
            ? nativeInfo
            : JSON.parse(nativeInfo as string)
        const userCountry = nativeData?.country || 'us'
        const countryCode = userCountry.toUpperCase()

        // 检查活动是否开启
        const isOfferEnabled = resObj.new_user_offer === true
        const isCountrySupported = resObj.new_user_offer_country?.includes(countryCode) || false
        const isActivityActive = isOfferEnabled && isCountrySupported
        setIsActivityEnabled(isActivityActive)

        // 只有活动开启且国家支持时才返回折扣信息
        if (isActivityActive) {
          const discountPrices = resObj?.new_user_discount_package_price || []
          setNewYearPrice(discountPrices)
          return discountPrices
        } else {
          setNewYearPrice([])
          return []
        }
      } else {
        setNewYearPrice([])
        return []
      }
    } catch (error) {
      console.log('getNewYearSupport error:', error)
      setNewYearPrice([])
      return []
    }
  }, [])
  // 获取套餐
  const getPlan = useCallback(
    (token) => {
      const url = `/v1/cloud/get_packages`
      request<any>({
        url,
        // headers: {
        //   'X-Auth-Token': token,
        // },
        method: 'post',
        data: {
          // class_id: classId,
          classId: null,
          service_code: 'monitoring.service',
          provider: 'stripe',
        },
      })
        .then(json => {
          if (json.code === 0) {
            const data = json.data
            for (const i in data) {
              if (data[i].class_id !== 0) {
                if (data[i].is_trial) {
                  setIsTrialed(true)
                }
                // 过滤试用class_id=0
                if (
                  data[i].class_id === 1 &&
                  data[i].date_type === 1 &&
                  data[i].device_num === 1
                ) {
                  // basic 套餐
                  setPackageNo(json.data[i].package_no)
                  isBasicTrialed = json.data[i].trialed === false ? true : false
                  setBtnText(
                    json.data[i].trialed === false
                      ? 'Start Trial'
                      : 'Get Started'
                  )
                  // 把plus套餐存起来，在try demo页面就不用请求接口直接取，否则会导致请求3个接口
                  sessionStorage.setItem(
                    'packageBasicNo',
                    json.data[i].package_no
                  )
                }
                if (
                  data[i].class_id === 2 &&
                  data[i].date_type === 1 &&
                  data[i].device_num === 1
                ) {
                  setPackagePlusNo(data[i].package_no)
                  isPlusTrialed = data[i].trialed === false ? true : false
                  setBtnText(
                    data[i].trialed === false ? 'Start Trial' : 'Get Started'
                  )
                  const uploadVal = JSON.stringify({
                    entry: urlParams.entrance,
                    isTrial: btnText === 'Start Trial' ? 'free' : 'paid',
                  }) // 事件参数
                  if (!isIntroPage(props.page)) return
                  if (isAndroid) {
                    getUserInfo('version').then(version => {
                      if (Number(version) === 1) {
                        getAlramServiceWaysToBuy().then((val: string) => {
                          if (JSON.parse(val || '{}').ways === 'email') {
                            uploadTrackings({
                              events: [
                                {
                                  type: String(190087), // 事件名称
                                  extra: 'isTrial',
                                  value: uploadVal,
                                  ts: parseInt((Date.now() / 1000).toString()), // 时间戳(毫秒)
                                },
                              ],
                            })
                          } else {
                            uploadTrackings({
                              events: [
                                {
                                  type: String(190088),
                                  extra: 'isTrial',
                                  value: uploadVal,
                                  ts: parseInt((Date.now() / 1000).toString()), // 时间戳(毫秒)
                                },
                              ],
                            })
                          }
                        })
                      } else if (Number(version) === 2) {
                        uploadTrackings({
                          events: [
                            {
                              type: String(190087), // 事件名称
                              extra: 'isTrial',
                              value: uploadVal,
                              ts: parseInt((Date.now() / 1000).toString()), // 时间戳(毫秒)
                            },
                          ],
                        })
                      }
                    })
                  } else {
                    uploadTrackings({
                      events: [
                        {
                          type: String(190087), // 事件名称
                          extra: 'isTrial',
                          value: uploadVal,
                          ts: parseInt((Date.now() / 1000).toString()), // 时间戳(毫秒)
                        },
                      ],
                    })
                  }
                }
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    [btnText, props.page, isAndroid]
  )

  // 获取 Apple provider 的年付套餐数据
  const getAppleYearPlan = useCallback(
    (
      discountPrices?: Array<{
        package_no: string
        buy_channel: string
        price: number
      }>
    ) => {
      // 使用传入的折扣数据，如果没有则使用状态中的 newYearPrice
      const currentDiscountPrices = discountPrices || newYearPrice
      const url = `/v1/cloud/get_packages`
      request<any>({
        url,
        method: 'post',
        data: {
          classId: null,
          service_code: 'monitoring.service',
          provider: judgeClient().toLowerCase() === 'ios' ? 'apple' : 'google'
        },
      })
        .then(json => {
          if (json.code === 0) {
            const data = json.data
            console.log(data, 'data')
            for (const i in data) {
              if (data[i].class_id !== 0) {
                // 获取年付数据 (date_type === 3)
                // device_type: 0-basic, 1-plus
                if (data[i].date_type === 3 && data[i].device_num === 1) {
                  const deviceType = data[i].device_type
                  const originalPrice = data[i].price
                  const packageNo = data[i].package_no
                  const buyChannel = data[i].buy_channel || 'stripe' // 默认为 stripe，如果接口返回的是数字需要转换

                  // 立即尝试匹配折扣价格
                  let discountPrice = originalPrice
                  let oldPrice: number | undefined = undefined

                  if (deviceType === 0) {
                    // basic 年付
                    setYearPackageNoBasic(packageNo)
                    setYearOriginalPriceBasic(originalPrice)
                    // 立即尝试匹配折扣 - 同时匹配 package_no 和 buy_channel
                    const discountInfo = currentDiscountPrices.find(
                      item =>
                        item.package_no === packageNo &&
                        (item.buy_channel === buyChannel ||
                          item.buy_channel === String(buyChannel) ||
                          String(item.buy_channel) === String(buyChannel))
                    )
                    // 如果同时匹配 buy_channel 没找到，尝试只匹配 package_no
                    const discountInfoFallback =
                      discountInfo ||
                      currentDiscountPrices.find(
                        item => item.package_no === packageNo
                      )

                    const finalDiscountInfo =
                      discountInfo || discountInfoFallback
                    if (
                      finalDiscountInfo &&
                      finalDiscountInfo.price !== originalPrice
                    ) {
                      discountPrice = finalDiscountInfo.price
                      oldPrice = originalPrice
                    }
                    setYearPriceBasic({
                      price: discountPrice,
                      oldPrice: oldPrice,
                    })
                  } else if (deviceType === 1) {
                    // plus 年付
                    setYearPackageNoPlus(packageNo)
                    setYearOriginalPricePlus(originalPrice)
                    // 立即尝试匹配折扣 - 同时匹配 package_no 和 buy_channel
                    const discountInfo = currentDiscountPrices.find(
                      item =>
                        item.package_no === packageNo &&
                        (item.buy_channel === buyChannel ||
                          item.buy_channel === String(buyChannel) ||
                          String(item.buy_channel) === String(buyChannel))
                    )
                    // 如果同时匹配 buy_channel 没找到，尝试只匹配 package_no
                    const discountInfoFallback =
                      discountInfo ||
                      currentDiscountPrices.find(
                        item => item.package_no === packageNo
                      )

                    const finalDiscountInfo =
                      discountInfo || discountInfoFallback
                    if (
                      finalDiscountInfo &&
                      finalDiscountInfo.price !== originalPrice
                    ) {
                      discountPrice = finalDiscountInfo.price
                      oldPrice = originalPrice
                    }

                    setYearPricePlus({
                      price: discountPrice,
                      oldPrice: oldPrice,
                    })
                  }
                }
              }
            }
          }
        })
        .catch(error => {
          console.log('getAppleYearPlan error:', error)
        })
    },
    [newYearPrice]
  )

  // 切换basic/plus
  const clickSwitchPlan = useCallback((val: number, clickPrice?: boolean) => {
    const id = val === 0 ? 1900167 : 1900168
    const priceTrackid = val === 0 ? 1900169 : 1900170
    uploadTrackings({
      events: [
        {
          type: String(clickPrice ? priceTrackid : id),
          extra: '',
          value: '',
          ts: parseInt((Date.now() / 1000).toString()),
        },
      ],
    })
    setCheckEndVal(val)
    setCheckEndNumber(val)
    // checkEndNumber = val
    let btnText = ''
    if (Number(val) === 0) {
      btnText = isBasicTrialed === true ? 'Start Trial' : 'Get Started'
    } else {
      btnText = isPlusTrialed === true ? 'Start Trial' : 'Get Started'
    }
    setBtnText(btnText)
  }, [])

  // to try
  const toTryDemo = useCallback(() => {
    uploadTrackings({
      events: [
        {
          type: String(1900140),
          extra: '',
          value: '',
          ts: parseInt((Date.now() / 1000).toString()),
        },
      ],
    })
    uploadTrackings({
      events: [
        {
          type: String(1900166),
          extra: '',
          value: 'click_see_demo',
          ts: parseInt((Date.now() / 1000).toString()),
        },
      ],
    })
    const is_trial =
      Number(checkEndNumber) === 0 ? isBasicTrialed : isPlusTrialed
    const isPackage_no =
      Number(checkEndNumber) === 0 ? package_no : packagePlus_no
    const search = qs.stringify({
      is_trial,
      isPackage_no,
      ...utm,
      ...urlParams,
      from: window.location.href,
    })
    navigate(`/monitoring/try-demo/?${search}`)
  }, [package_no, packagePlus_no, utm, checkEndNumber])

  const manageSubscription = () => {
    if (isIOS) {
      window.location.href = 'eufysecurity://eufy/vas/myservice'
    } else {
      let iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = 'eufysecurity://eufy/vas/myservice'
      document.body.appendChild(iframe)
    }
  }

  const renderHTML = () => {
    const paragraphs = []

    for (let i = 1; i <= 70; i++) {
      paragraphs.push(
        <p className="policy" key={i}>
          {t(`protection_plan_terms.protection_plan_terms_content${i}`)}
        </p>
      )
    }
    return paragraphs
  }

  useEffect(() => {
    props.showSwiperBanner && startBanner()
    // 恢复 android 点返回虚拟键交互
    nativeApp({
      androidBack: () => {
        window.location.href = 'app://back'
      },
    })
    const search = window.location.search
    if (search?.indexOf?.('?') > -1) {
      const params = search.split('?')?.[1]?.split('&') as string[]
      urlParams = params.reduce((i, item) => {
        const [k, v] = item.split('=')
        return Object.assign(i, { [k]: v })
      }, {})
    }
    setQueryUrl(urlParams)
    setTimeout(async () => {
      try {
        // 先获取折扣信息
        const discountPrices = await getNewYearSupport()

        getUserInfo('userInfoData')
          .then(data => {
            setEmail(data.email)
            getPlan(data.token)
            // 获取 Apple provider 的年付套餐数据
            getAppleYearPlan(discountPrices)
            getCloudPlanListClassList(data.token)
            if (sessionStorage.getItem('planType')) {
              // 从try demo购买页面过来选中的是basic/plus
              const planType =
                sessionStorage.getItem('planType') === 'Basic' ? 0 : 1
              setCheckEndVal(planType)
              setCheckEndNumber(planType)
              //  checkEndNumber = planType
              sessionStorage.removeItem('planType')
            }
            // 获取套餐判断是否已订阅 todo
            getCurrentSubscription().then(res => {
              setSubscriptions(res?.data?.Subscriptions || [])
              // 判断用户类型
              const type = getUserType(res?.data)
              setUserType(type)
            })
          })
          .catch(error => {
            setPackageNo('0')
            setPackagePlusNo('0')
            setBtnText('Get Started')
          })
      } catch (error) {}
    }, 500)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setFirstLocalStorage = (key: string, fun: any) => {
    const first = window.localStorage.getItem(key)
    if (first === 'true') {
      window.localStorage.setItem(key, 'false')
      fun(false)
    } else if (first === 'false') {
      fun(false)
    } else {
      window.localStorage.setItem(key, 'true')
      fun(true)
    }
  }

  useEffect(() => {
    if (from === 'luckydraw') {
      setLuckyInfoVisible(true)
    } else {
      // terms
      // setFirstLocalStorage('protection_first_terms', setTermsShow)
    }
    // 记录停留时间
    setTopTime(parseInt((Date.now() / 1000).toString()))
  }, [from])

  useEffect(() => {
    let { utm_source, utm_campaign } = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })
    if (typeof utm_source === 'string' && utm_source) {
      window.localStorage.setItem('utm_source', utm_source)
    } else {
      utm_source = window.localStorage.getItem('utm_source') || ''
    }
    if (typeof utm_campaign === 'string' && utm_campaign) {
      window.localStorage.setItem('utm_campaign', utm_campaign)
    } else {
      utm_campaign = window.localStorage.getItem('utm_campaign') || ''
    }
    setUtm({ utm_source, utm_campaign })
  }, [])

  useEffect(() => {
    if (props?.exposeTrackid) {
      uploadTrackings({
        events: [
          {
            type: String(props.exposeTrackid), // 事件名称
            value: '', // 事件参数
            ts: parseInt((Date.now() / 1000).toString()), // 时间戳(毫秒)
          },
        ],
      })
    }
  }, [props.exposeTrackid])

  // useEffect(() => {
  //   tabTop = tabRef.current?.offsetTop
  // }, [])

  useEffect(() => {
    togglePullToRefresh(true)
    const t = setTimeout(() => {
      scrollToTop()
      clearTimeout(t)
    }, 300)
  }, [])

  useEffect(() => {
    const client = judgeClient()
    setIsAndroid(client === 'Android')
    setIsIOS(client === 'iOS')
  }, [])

  useAsyncEffect(async () => {
    setNativeInfo(await getNativeInfo())
  }, [])

  useUpdateEffect(() => {
    uploadTrackings({
      events: [
        {
          type: String(UtmTrackId.expose), // 事件名称
          extra: JSON.stringify(utm),
          value: JSON.stringify({
            page: props.page,
            plan: checkEndVal === 0 ? 'basic' : 'plus',
            istrial: btnText === 'Start Trial',
          }), // 事件参数
          ts: parseInt((Date.now() / 1000).toString()), // 时间戳(毫秒)
        },
      ],
    })
  }, [utm])

  // 当折扣信息更新后，更新年付价格
  useEffect(() => {
    if (yearOriginalPriceBasic > 0) {
      let discountPrice = yearOriginalPriceBasic
      let oldPrice: number | undefined = undefined

      // 即使 newYearSupport 为 false，也尝试匹配折扣价格（用于测试）
      if (newYearPrice.length > 0 && yearPackageNoBasic) {
        const discountInfo = newYearPrice.find(
          item => item.package_no === yearPackageNoBasic
        )

        if (discountInfo && discountInfo.price !== yearOriginalPriceBasic) {
          discountPrice = discountInfo.price
          oldPrice = yearOriginalPriceBasic
        }
      }

      setYearPriceBasic({
        price: discountPrice,
        oldPrice: oldPrice,
      })
    }

    if (yearOriginalPricePlus > 0) {
      let discountPrice = yearOriginalPricePlus
      let oldPrice: number | undefined = undefined

      // 即使 newYearSupport 为 false，也尝试匹配折扣价格（用于测试）
      if (newYearPrice.length > 0 && yearPackageNoPlus) {
        const discountInfo = newYearPrice.find(
          item => item.package_no === yearPackageNoPlus
        )
        if (discountInfo && discountInfo.price !== yearOriginalPricePlus) {
          discountPrice = discountInfo.price
          oldPrice = yearOriginalPricePlus
        }
      }

      setYearPricePlus({
        price: discountPrice,
        oldPrice: oldPrice,
      })
    }
  }, [
    newYearSupport,
    newYearPrice,
    yearPackageNoBasic,
    yearPackageNoPlus,
    yearOriginalPriceBasic,
    yearOriginalPricePlus,
  ])

  const goTerms = () => {
    const url =
      process.env.NODE_ENV === 'development' || isQa()
        ? 'https://security-app-qa.eufylife.com'
        : 'https://security-app.eufylife.com'
    openWebview(`${url}/v1/overall/termsof?type=termsofprotectionplan`)
  }
  return (
    <div className={styles.container} style={{ background: '#f5f5f5' }}>
      <Helmet title="eufy Protection Plan" />
      {/* 加载中 */}
      {/* <section className="loading" style={{display: package_no!==''&&package_no!=='' ? 'none' : 'block'}}>
        <img src={loading} alt="" className="loading-img" />
      </section> */}
      {/* 弹窗modal */}
      <section
        className={styles.modalStyle}
        style={{ display: modalVisible ? 'block' : 'none' }}
      >
        <div>
          <p> {openEmailTextTips} </p>
          {
            // eslint-disable-next-line no-mixed-operators
            isIOS || (isAndroid && emailText === '') ? (
              <button
                onClick={() => setModalVisible(false)}
                style={{ background: '#0b6288', color: '#fff' }}
              >
                OK
              </button>
            ) : (
              <section>
                <button onClick={() => openEmail()}>Check the Email</button>
                <br />
                <button
                  className={styles.btnCancel}
                  onClick={() => setModalVisible(false)}
                >
                  Cancel
                </button>
              </section>
            )
          }
        </div>
      </section>

      <div className={styles.header}>
        <span className={styles.backBox} onClick={() => handleGoBack()}>
          <img src={BackIcon} alt="" className={styles.backIcon} />
        </span>
        <span className={styles.backTitle}>
          {props.config.title || t('protection_plan_h5_title')}
        </span>
      </div>

      {props?.showSwiperBanner && (
        <section className={styles.banner}>
          <div className="swiper-container">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <img src={banner1} alt="" />
              </div>
              <div className="swiper-slide">
                <img src={banner2} alt="" />
              </div>
              <div className="swiper-slide">
                <img src={banner3} alt="" />
              </div>
            </div>
          </div>
        </section>
      )}

      {!props?.showSwiperBanner && props?.config?.banner && (
        <section className={styles.NorBanner}>
          <div className={styles.BannerImg}>
            <img src={props.config.banner.img} alt="banner" />
          </div>
          <p className={styles.BannerText}>{props.config.banner.desc}</p>
        </section>
      )}

      {/* sty 模拟试用 */}
      {/* <section className={styles.sty}>
        <h6>
          Let's simulate the entire triggered process
          <span onClick={()=> toTryDemo()}>Try out</span>
        </h6>
      </section> */}
      {/* basic/plus切换 */}

      {props.config?.reasons && (
        <section className={classnames(styles.hows, styles.block)}>
          <h2>{props.config?.reasons.title}</h2>
          <div className={styles.tabWrapper}>
            {props.config?.reasons.list?.map((item, index) => (
              <div key={index} className={styles.howsWraper}>
                <img src={item.icon} alt="icon" />
                <div className={styles.htwsText}>
                  <h3 style={{ fontWeight: 'normal' }}>{item.description}</h3>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      <section
        className={styles.planSwitch}
        ref={tabRef}
        style={{ marginTop: props.hideTab ? 15 : undefined }}
      >
        {!props.hideTab && (
          <div className={classnames('planSwitch-title')}>
            <span
              className={
                checkEndVal === 1 ? 'plan-plus plan-active' : 'plan-plus'
              }
              onClick={() => clickSwitchPlan(1)}
            >
              {t('protection_plan_h5_price_plus_name')}
            </span>
            <span
              className={
                checkEndVal === 0 ? 'plan-basic plan-active' : 'plan-basic'
              }
              onClick={() => clickSwitchPlan(0)}
            >
              {t('protection_plan_h5_price_basic_name')}
            </span>
          </div>
        )}
        <div className={classnames(styles.stay, styles.block)}>
          {props.hideTab && (
            <h2 style={{ marginBottom: 0 }}>
              {t('protection_plan_h5_basic_benefit')}
            </h2>
          )}
          {checkEndVal === 1 && (
            <ul className={styles.stayUl}>
              {benifits.plus.map((item, i) => (
                <li key={i}>
                  <img src={item.icon} alt="icon" />
                  <p className={styles.p}>{item.description}</p>
                </li>
              ))}
            </ul>
          )}
          {checkEndVal === 0 && (
            <ul className={styles.stayUl}>
              {benifits.basic.map((item, i) => (
                <li key={i}>
                  <img src={item.icon} alt="icon" />
                  <p className={styles.p}>{item.description}</p>
                </li>
              ))}
            </ul>
          )}
        </div>
      </section>

      <section className={classnames(styles.hows, styles.block)}>
        <h2>{t('protection_plan_h5_htw_title')}</h2>
        <div className={styles.tabWrapper}>
          {(checkEndVal === 1 ? htws.plus : htws.basic).map((item, index) => (
            <div key={index} className={styles.howsWraper}>
              <img src={item.icon} alt={item.title} />
              <div className={styles.htwsText}>
                <h3>
                  {`${index + 1}. `}
                  {item.title}
                </h3>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className={classnames(styles.reliable, styles.block)}>
        <h2>{t('protection_plan_h5_priority_title')}</h2>
        <div className={styles.reliableWraper}>
          <div className={styles.secodes}>
            <div>
              <h4>{t('protection_plan_h5_priority_5s')}</h4>
              <p>{t('protection_plan_h5_priority_5s_desc')}</p>
            </div>
            <img src={sec5} alt="" />
          </div>
          <div className={styles.secodes}>
            <div>
              <h4>{t('protection_plan_h5_priority_30s')}</h4>
              <p>{t('protection_plan_h5_priority_30s_desc')}</p>
            </div>
            <img src={sec30} alt="" />
          </div>
          <div className={styles.secodes}>
            <div>
              <h4>{t('protection_plan_h5_priority_60s')}</h4>
              <p>{t('protection_plan_h5_priority_60s_desc')}</p>
            </div>
            <img src={sec60} alt="" />
          </div>
        </div>
      </section>

      <section
        className={classnames(styles.planBenefits, styles.block)}
        style={{ paddingBottom: comparisons.length % 2 === 0 ? undefined : 20 }}
      >
        <h2>{t('protection_plan_h5_comparsion_title')}</h2>
        <table className="table">
          <tbody>
            <tr>
              <td></td>
              {comparisons[0].plus !== null && <td>Plus</td>}
              <td>Basic</td>
              <td>No Plan</td>
            </tr>
            {comparisons.map((item, index) => (
              <tr key={index}>
                {item.info ? (
                  <td>
                    <span
                      data-background-color="rgba(0,0,0,.8)"
                      data-tip={item.info}
                      data-event="click focus"
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    ></span>
                    <i className="info"></i>
                    <ReactTooltip globalEventOff="click" />
                  </td>
                ) : (
                  <td>
                    <span
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    ></span>
                  </td>
                )}
                {item.plus !== null && (
                  <td>
                    <div className={item.plus ? 'select' : 'noSelect'} />
                  </td>
                )}
                <td>
                  <div className={item.basic ? 'select' : 'noSelect'} />
                </td>
                <td>
                  <div className={item.noplan ? 'select' : 'noSelect'} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
      {!!plans?.length && (
        <section className={styles.Plan}>
          {/* 活动开启且是新用户时，展示年付折扣价格 */}
          {isActivityEnabled && userType === 3 ? (
            <>
              <div
                className={classnames(styles.PlanChoice, 'plus', {
                  [styles.Active]: checkEndVal === 1,
                })}
              >
                <div className={styles.PlanChoiceHeader}>
                  {yearPricePlus?.oldPrice && (
                    <span className={styles.DiscountBadge}>
                      {t('protection_plan_h5_discount_limited_time')}{' '}
                      {Math.round(
                        ((yearPricePlus.oldPrice - yearPricePlus.price) /
                          yearPricePlus.oldPrice) *
                          100
                      )}
                      % {t('protection_plan_h5_discount_off')}
                    </span>
                  )}
                  <span className={styles.PlanTitle}>
                    {t('protection_plan_h5_price_plus_name')}
                  </span>
                </div>
                <div
                  className={styles.PlanChoiceBody}
                  onClick={() => clickSwitchPlan(1, true)}
                >
                  <h4>
                    {yearPricePlus ? (
                      <>
                        <span className={styles.PriceCurrent}>
                          ${(yearPricePlus.price / 100).toFixed(2)}/{t('protection_plan_h5_discount_year')}
                        </span>
                        {yearPricePlus.oldPrice && (
                          <span className={styles.PriceOriginal}>
                            ${(yearPricePlus.oldPrice / 100).toFixed(2)}/{t('protection_plan_h5_discount_year')}
                          </span>
                        )}
                      </>
                    ) : (
                      t('protection_plan_h5_price_plus_month')
                    )}
                  </h4>
                  <p>{t('protection_plan_h5_price_plus_info')}</p>
                  <img src={checkEndVal === 1 ? Selected : Select} alt="select" />
                </div>
              </div>
              <div
                className={classnames(styles.PlanChoice, 'basic', {
                  [styles.Active]: checkEndVal === 0,
                })}
              >
                <div className={styles.PlanChoiceHeader}>
                  {yearPriceBasic?.oldPrice && (
                    <span className={styles.DiscountBadge}>
                      {t('protection_plan_h5_discount_limited_time')}{' '}
                      {Math.round(
                        ((yearPriceBasic.oldPrice - yearPriceBasic.price) /
                          yearPriceBasic.oldPrice) *
                          100
                      )}
                      % {t('protection_plan_h5_discount_off')}
                    </span>
                  )}
                  <span className={styles.PlanTitle}>
                    {t('protection_plan_h5_price_basic_name')}
                  </span>
                </div>
                <div
                  className={styles.PlanChoiceBody}
                  onClick={() => clickSwitchPlan(0, true)}
                >
                  <h4>
                    {yearPriceBasic ? (
                      <>
                        <span className={styles.PriceCurrent}>
                          ${(yearPriceBasic.price / 100).toFixed(2)}/{t('protection_plan_h5_discount_year')}
                        </span>
                        {yearPriceBasic.oldPrice && (
                          <span className={styles.PriceOriginal}>
                            ${(yearPriceBasic.oldPrice / 100).toFixed(2)}/{t('protection_plan_h5_discount_year')}
                          </span>
                        )}
                      </>
                    ) : (
                      t('protection_plan_h5_price_basic_month')
                    )}
                  </h4>
                  <p>{t('protection_plan_h5_price_basic_info')}</p>
                  <img src={checkEndVal === 0 ? Selected : Select} alt="select" />
                </div>
              </div>
            </>
          ) : (
            <>
              {/* 其他情况展示月付价格 */}
              <div
                className={classnames(styles.PlanChoice, 'plus', {
                  [styles.Active]: checkEndVal === 1,
                })}
              >
                <div className={styles.PlanChoiceHeader}>
                  {t('protection_plan_h5_price_plus_name')}
                </div>
                <div
                  className={styles.PlanChoiceBody}
                  onClick={() => clickSwitchPlan(1, true)}
                >
                  <h4>{t('protection_plan_h5_price_plus_month')}</h4>
                  <p>{t('protection_plan_h5_price_plus_info')}</p>
                  <img src={checkEndVal === 1 ? Selected : Select} alt="select" />
                </div>
              </div>
              <div
                className={classnames(styles.PlanChoice, 'basic', {
                  [styles.Active]: checkEndVal === 0,
                })}
              >
                <div className={styles.PlanChoiceHeader}>
                  {t('protection_plan_h5_price_basic_name')}
                </div>
                <div
                  className={styles.PlanChoiceBody}
                  onClick={() => clickSwitchPlan(0, true)}
                >
                  <h4>{t('protection_plan_h5_price_basic_month')}</h4>
                  <p>{t('protection_plan_h5_price_basic_info')}</p>
                  <img src={checkEndVal === 0 ? Selected : Select} alt="select" />
                </div>
              </div>
            </>
          )}
        </section>
      )}
      {/* 报警服务另一个页面monitoring/keypad/ */}
      {!!planStyles?.length && (
        <section className={styles.Plan}>
          {planStyles.map(item => (
            <div
              key={item.id}
              className={classnames(styles.PlanChoice, {
                [styles.Active]: planStyle === item.id,
              })}
            >
              <div className={styles.PlanChoiceHeader}>{item.title}</div>
              <div
                className={styles.PlanChoiceBody}
                onClick={() => setPlanStyle(item.id)}
              >
                <h4>{item.display_price}</h4>
                <p className={styles.Discount}>{item.dispatch}</p>
                <img
                  src={planStyle === item.id ? Selected : Select}
                  alt="select"
                />
              </div>
            </div>
          ))}
        </section>
      )}

      <section className={classnames(styles.connected, styles.block)}>
        <h2>{t('protection_plan_h5_agent')}</h2>
        <p>
          Powered by
          <i />
        </p>
        <p>
          Enhanced by advanced technology and TMA Five Diamond Certified Centers
        </p>
        <p>Join 2 million+ people already protected</p>
        <div className="identification">
          <img src={origin_img_v1} alt="" />
          <img src={origin_img_v2} alt="" />
        </div>
      </section>

      <section className={classnames(styles.faq, styles.block)}>
        <h2>{t('protection_plan_h5_faq')}</h2>
        <div className={styles.faqWraper}>
          {FAQs(isTrialAvailable, props.config.faqs).map((v, index) => (
            <Collapse
              key={index}
              title={v[0]}
              children={
                <span dangerouslySetInnerHTML={{ __html: v[1] }}></span>
              }
            />
          ))}
        </div>
      </section>
      <section
        className={styles.floating}
        // style={{
        //   display:
        //     packagePlus_no !== '' && classList.length > 0 ? 'block' : 'none',
        // }}
      >
        {/* {isAllowActivity && <p className={styles.floatingTip}>{t('protection.protection_plan_h5_202211_promo_tips')}</p>} */}
        <div className={styles.floatingBody}>
          {/* {subscriptions.length && queryUrl?.subscribeType !== '1' ? (
            <div
              className={styles.floatingStart}
              onClick={() => manageSubscription()}
              style={{ width: '100%' }}
            >
              Manage Subscription
            </div>
          ) : (
            <> */}
              <div
                className={styles.floatingEmpty}
                style={{ display: isIOS ? undefined : 'none' }}
              ></div>
              {!props?.hideTryDemo && (
                <div className={styles.floatingDemo} onClick={toTryDemo}>
                  <img src={Demo} alt="demo" />
                  <span>{t('protection_plan_h5_see_demo')}</span>
                </div>
              )}
              <div
                className={classnames(styles.floatingStart, { [styles.floatingStartLoading]: !btnText })}
                onClick={() => btnText && handleClick()}
              >
                {btnText || 'Loading...'}
              </div>
            {/* </>
          )} */}
        </div>

        {subscriptions.length && queryUrl?.subscribeType !== '1' ? (
          <div className={styles.clause} onClick={goTerms}>
            {t('cloud.terms_and_Conditions')}
          </div>
        ) : null}
        {/* <div className={styles.floatingBody}>
          {isAllowActivity && <p>{t('protection.protection_plan_h5_202211_promo_tips')}</p>}
          {!props?.hideTryDemo && (
            <div className={styles.floatingDemo} onClick={toTryDemo} style={{marginLeft: isAndroid ? undefined : 50}}>
              <img src={Demo} alt="demo" />
              <span>{t('protection_plan_h5_see_demo')}</span>
            </div>
          )}
          <div className={styles.floatingStart} onClick={()=>handleClick()}>
            {btnText}
          </div>
        </div> */}
      </section>

      <section
        className={styles.tips}
        style={{ display: tips ? 'block' : 'none' }}
      >
        Service Error
      </section>

      {/* 已订阅提示弹窗 */}
      <section
        className={styles.modalStyle}
        style={{ display: subscribedModalVisible ? 'block' : 'none' }}
      >
        <div>
          <p>{t('cloud.bc_apple_pay_already_subscribed')}</p>
          <p>{t('cloud.bc_apple_pay_want_to_change_plan')}</p>
          <button
            onClick={() => manageSubscription()}
            style={{ background: '#0b6288', color: '#fff' }}
          >
            {t('MyServices')}
          </button>
          <button
            className={styles.btnCancel}
            onClick={() => setSubscribedModalVisible(false)}
          >
            OK
          </button>
        </div>
      </section>

      <Modal
        visible={luckyInfoVisible}
        content={
          <div dangerouslySetInnerHTML={{ __html: luckyDrawPopUpTxt }} />
        }
        actions={
          <div
            className={styles.popupBtn}
            onClick={() => {
              setLuckyInfoVisible(false)
              // setFirstLocalStorage('protection_first_terms', setTermsShow)
            }}
          >
            Learn More
          </div>
        }
      ></Modal>
      <Modal
        visible={false}
        content={
          <div>
            <h4>{t('protection_plan_terms.protection_plan_terms_title')}</h4>
            <span className="policy">
              {t('protection_plan_terms.protection_plan_terms_time')}
            </span>
            <p className="content-wrap-portection">{renderHTML()}</p>
          </div>
        }
        actions={
          <div
            className={styles.popupBtn}
            onClick={() => {
              // setTermsShow(false)
            }}
          >
            {t('protection_plan_terms.protection_plan_terms_confirm')}
          </div>
        }
      ></Modal>

      <div
        className={classnames(styles.BackToTop, {
          [styles.Visible]: backToTopVisible,
          [styles.Top]: props.hideTab,
        })}
        onClick={scrollToTop}
      >
        {t('protection_plan_h5_back_to_top')}
      </div>
    </div>
  )
}

export default MonitoringServicePage
